import { jsx, jsxs } from "react/jsx-runtime";
import { Switch } from "@base-ui/react/switch";
import { forwardRef, useCallback } from "react";
import { toggleVariants } from "./Toggle.variants.js";
const Toggle_Toggle = /*#__PURE__*/ forwardRef(function({ checked, disabled, name, required, size = '24', onToggle, emphasis = 'regular' }, ref) {
    const { root, slider, tapSpaceSlot } = toggleVariants({
        size,
        emphasis
    });
    const onCheckedChange = useCallback((checked, eventDetails)=>{
        onToggle?.(checked, eventDetails?.event);
    }, [
        onToggle
    ]);
    return /*#__PURE__*/ jsxs(Switch.Root, {
        className: root(),
        checked: checked,
        disabled: disabled,
        inputRef: ref,
        name: name,
        required: required,
        onCheckedChange: onCheckedChange,
        children: [
            /*#__PURE__*/ jsx("div", {
                className: tapSpaceSlot()
            }),
            /*#__PURE__*/ jsx(Switch.Thumb, {
                className: slider()
            })
        ]
    });
});
export { Toggle_Toggle as Toggle };
